const isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style

export const smoothScroll = (elem: HTMLElement, { top, left }: { top: number; left: number }) => {
  if (isSmoothScrollSupported) {
    elem.scrollTo({ top, left, behavior: 'smooth' })
    return
  }
  elem.scrollTo(top, left)
}
